import { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../themes/theme.provider';
import QuestionPaginationComponent from './component/question-pagination.component';
import FilterByComponent from './component/filter-by.component';
import FullScreenComponent from './component/full-screen.component';
import InstructionComponent from './component/instruction.component';
import OverviewComponent from './component/overview.component';
import QuestionHolderComponent from './component/question-holder.component';
import SectionPickerComponent from './component/section-picker.component';
import SideMenuComponent from './component/side-menu.component';
import TimerComponent from './component/timer.component';
import PreviousNextComponent from './component/previous-next.component';
import QuestionInfoComponent from './component/question-info.component';
import { useUser } from '../../hook/user.hook';
import SaveStatusComponent from './component/save-status.component';

const TestMPage = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const { candidateConfig } = useUser();
  const [isOpenBottomWarpper, setIsOpenBottomWarpper] = useState(false);

  const handleBottomWrapper = () => {
    setIsOpenBottomWarpper(!isOpenBottomWarpper);
  };

  return (
    <>
      <section
        className="pt-3 d-flex flex-column mweb-section pb-0"
        style={{ height: '100dvh', overflow: 'hidden' }}
      >
        <Row className="m-0 mb-1 flex-shrink-0">
          <Col
            lg={12}
            className="px-3 border-bottom border-gainsboro pb-2 text-white d-flex align-items-center"
          >
            <SideMenuComponent />

            {candidateConfig?.candidate && (
              <span className="px-2">
                {candidateConfig.candidate.enrollmentId ?? 'Hi, Student'}
              </span>
            )}
            <div className="border-start border-gainsboro">
              <img src="/images/logo-tr.svg" width="80" height="24" alt="" />
            </div>

            <div className="ms-auto d-flex align-items-center">
              <FullScreenComponent />

              <OverviewComponent />
            </div>
          </Col>
        </Row>
        <div className="py-2 px-3 d-flex align-items-center justify-content-between flex-shrink-0">
          <InstructionComponent />
          <TimerComponent />
        </div>

        <div
          className="bg-secondary rounded-25 px-3 m-3 flex-grow-1"
          style={{ overflowY: 'auto', minHeight: 0 }}
        >
          <QuestionHolderComponent />
        </div>

        <div
          className={`bottom--wrapper bg-secondary d-flex align-items-center text-center flex-column py-2 flex-shrink-0 ${
            isOpenBottomWarpper ? 'opend' : ''
          } `}
        >
          <Button
            variant="link"
            className="text-white p-0 border-0"
            onClick={handleBottomWrapper}
          >
            <img
              src={`/images/${
                isOpenBottomWarpper ? 'down-arrow.svg' : 'up-arrow.svg'
              }`}
              alt=""
            />
          </Button>

          <div className="w-100">
            <PreviousNextComponent />
            {isOpenBottomWarpper && (
              <>
                <div className="border-top border-gray mt-2 py-2">
                  <QuestionInfoComponent />

                  <div className="d-flex align-items-center justify-content-between px-3">
                    <SectionPickerComponent />
                    <FilterByComponent />
                  </div>

                  <div
                    style={{ background: theme.primary }}
                    className=" w-100 mweb--pagination-wrapper mt-3 px-3 py-4 d-flex justify-content-center align-items-center flex-column"
                  >
                    <QuestionPaginationComponent />

                    <SaveStatusComponent fontSize="ft-12" />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default TestMPage;
